import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {safeAdd} from 'common/utils';
import DynamicElement from '../../shared/DynamicElement';

export const EmployeePayment = (props) => {
  const {
    employeePayment,
    employee,
    editable,
    itemConfig
  } = props;

  const groupByRows = _.chain(
    _.get(itemConfig, 'itemCardContents.detailSection.paymentRequestGrid')
  )
  .groupBy('rowOrder')
  .map((value, key) => value)
  .value();

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>{_.get(employee, 'name')}</Grid.Column>
      </Grid.Row>
      {employee.duringPaymentPeriod ? (
        <React.Fragment>
          <Form>
            {_.map(groupByRows, (data, rowIndex) => {
              let key = 0 + '_' + rowIndex;
              let annualTotal = safeAdd(_.get(employeePayment, 'annualSalary', 0),
                _.get(employeePayment, 'annualBenefits', 0));
              let employeePaymentToDisplay = {...employeePayment, annualTotal}
              return (
                <div
                  key={props.id + '_div_' + key}
                  className="app-form-row margin-bottom-25"
                >
                  {_.map(data, (conf) => {
                    return (
                      <DynamicElement
                        key={conf.name + 
                          _.get(employee, 'rosterId') +
                          _.get(employee, 'positionId')}
                        id={_.get(employee, 'rosterId')}
                        conf={conf}
                        index={employee.positionId}
                        cost={employeePaymentToDisplay}
                        handleBlur={props.handleBlur}
                        handleItemChange={props.handleChange}
                        validationErrors={props.validationErrors}
                        validationDirtyMap={props.validationDirtyMap}
                        editable={editable}
                        costItemType={'employee'}
                      />
                    );
                  })}
                </div>
              );
            })}
          </Form>
        </React.Fragment>
      ) : (
        <Grid.Row>
          <Grid.Column>
            <strong>Employee not valid for payment</strong>
          </Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

export default EmployeePayment;
